export const ensureEnvVariable = (
  envVariable: string,
  fallback = "",
): string => {
  const env = process.env[envVariable] ?? fallback;
  if (fallback === "" && !env && envVariable !== "HEAD") {
    throw new Error(`Missing env variable ${envVariable}`);
  }
  return env;
};
